<div class="d-flex gap-1">
  <syslink-badge
    *ngFor="let item of items"
    [content]="item.text"
    [foregroundColor]="item.foregroundColor"
    [backgroundColor]="item.backgroundColor"
    [title]="item.title"
  ></syslink-badge>
</div>